module.exports = __webpack_public_path__ + "img/Iso_background_card_loyalty.cdbf713.svg";